<div class="footer-container" [ngClass]="{ mobile: isMobile() }">
  <div class="footer-content cont-width">
    <div class="justify-vert">
      <img
        ngSrc="logo-bw.svg"
        height="30"
        width="118.5"
        alt="GloboDog black and white logo." />
      <button
        *ngIf="!isOnApp"
        color="accent"
        mat-stroked-button
        (click)="openCookies()">
        {{ 'Sütibeállítások' | translate }}
      </button>
      <div *ngIf="!isMobile()" class="small-text">
        {{ '© 2023 GlodoDog Kft. - Minden jog fenntartva' | translate }}, v{{ version }}
      </div>
    </div>
    <div>
      <div class="footer-title left-padding">
        {{ 'Felhasználóknak' | translate }}
      </div>
      <div class="left-padding"></div>
      <ul class="left-padding">
        <li *ngIf="!isOnApp">
          <a
            href="{{
              restApiService.FILE_URL + staticFiles['tos'].files[currentLang()]
            }}"
            target="_blank"
            >{{ 'Oldalhasználati feltételek' | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/', currentLang(), 'gdpr']"
            >{{ 'GDPR' | translate }}</a
          >
        </li>
        <li *ngIf="!isOnApp">
          <a
            href="{{
              restApiService.FILE_URL +
                staticFiles['cookies'].files[currentLang()]
            }}"
            target="_blank"
            >{{ 'Cookie szabályzat' | translate }}</a
          >
          <!-- <a class="link" href="/pdf/sutiszabalyzat.pdf">{{
            'Cookie szabályzat' | translate
          }}</a> -->
        </li>
        <li>
          <a
            a
            [routerLink]="['/', currentLang(), 'faq-owner']"
            routerLinkActive="active"
            >{{ 'GY.I.K.' | translate }}</a
          >
        </li>
        <li>
          <a [routerLink]="['/', currentLang(), 'contact']">{{
            'Kapcsolat' | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="['/', currentLang(), 'about-us']">{{
            'Rólunk' | translate
          }}</a>
        </li>
      </ul>
    </div>
    <div>
      <div class="footer-title left-padding">
        {{ 'Szolgáltatóknak' | translate }}
      </div>
      <ul class="left-padding">
        <li>
          <a
            href="{{
              restApiService.FILE_URL + staticFiles['aszf'].files[currentLang()]
            }}"
            target="_blank"
            >{{ 'ÁSZF' | translate }}</a
          >
        </li>
        <li>
          <!--<a
            href="{{
              restApiService.FILE_URL + staticFiles['gdpr'].files[currentLang()]
            }}"
            target="_blank"
            >{{ 'GDPR' | translate }}</a
          >-->
          <a [routerLink]="['/', currentLang(), 'gdpr']">{{ 'GDPR' | translate }}</a>
        </li>
        <li *ngIf="!isOnApp">
          <a
            href="{{
              restApiService.FILE_URL +
                staticFiles['cookies'].files[currentLang()]
            }}"
            target="_blank"
            >{{ 'Cookie szabályzat' | translate }}</a
          >
          <!-- <a class="link" href="/pdf/sutiszabalyzat.pdf">{{
            'Cookie szabályzat' | translate
          }}</a> -->
        </li>
        <li>
          <a
            [routerLink]="['/', currentLang(), 'faq-provider']"
            routerLinkActive="active"
            >{{ 'GY.I.K.' | translate }}</a
          >
        </li>
        <li>
          <a [routerLink]="['/', currentLang(), 'contact']">{{
            'Kapcsolat' | translate
          }}</a>
        </li>
      </ul>
    </div>
    <div>
      <div class="footer-title left-padding">
        {{ 'Kövess minket!' | translate }}
      </div>
      <ul class="left-padding">
        <li>
          <a
            rel="noopener noreferrer"
            target="blank"
            href="https://www.facebook.com/GloboDog"
            >Facebook</a
          >
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="blank"
            href="https://www.instagram.com/globodog/"
            >Instagram</a
          >
        </li>
      </ul>
    </div>
    <div *ngIf="isMobile()" class="small-text">
      {{ '© 2023 GlodoDog Kft. - Minden jog fenntartva' | translate }}, v{{ version }}
    </div>
  </div>
</div>
